<div class="text-slate-800">
  <div class="flex flex-row justify-between items-center mb-8 lg:mb-10">
    <div class="flex gap-1 lg:gap-3 items-center">
      <div>
        <ng-content select="[icon]"></ng-content>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          class="hidden only:block"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.6665 23.6666V8.33325H26.3332V10.5029C24.7105 11.7834 23.6665 13.7677 23.6665 15.9999C23.6665 18.2322 24.7105 20.2164 26.3332 21.4969V23.6666H5.6665ZM26.6665 15.9999C26.6665 14.2583 27.7796 12.7766 29.3332 12.2275V7.99992C29.3332 6.52716 28.1393 5.33325 26.6665 5.33325H5.33317C3.86041 5.33325 2.6665 6.52716 2.6665 7.99992V23.9999C2.6665 25.4727 3.86041 26.6666 5.33317 26.6666H26.6665C28.1393 26.6666 29.3332 25.4727 29.3332 23.9999V19.7723C27.7796 19.2232 26.6665 17.7415 26.6665 15.9999ZM16.4964 13.9398L14.9997 9.33325L13.5029 13.9398H8.6593L12.5779 16.7868L11.0811 21.3934L14.9997 18.5464L18.9182 21.3934L17.4215 16.7868L21.3401 13.9398H16.4964Z"
            fill="#F5A70E"
          />
        </svg>
      </div>
      <h2 class="text-xl lg:text-2xl uppercase font-semibold">
        {{ listTitle }}
      </h2>
    </div>
    <button
      class="hidden lg:flex gap-3 items-center text-primary-500 text-xl font-semibold ms-auto"
      (click)="emitSeeAll()"
      *ngIf="showButton"
    >
      Ver todos
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17.2959 12.7959L9.7959 20.2959C9.58455 20.5072 9.29791 20.626 8.99902 20.626C8.70014 20.626 8.41349 20.5072 8.20215 20.2959C7.9908 20.0846 7.87207 19.7979 7.87207 19.499C7.87207 19.2001 7.9908 18.9135 8.20215 18.7021L14.9062 12L8.20402 5.2959C8.09937 5.19125 8.01636 5.06702 7.95973 4.93029C7.90309 4.79356 7.87394 4.64702 7.87394 4.49902C7.87394 4.35103 7.90309 4.20448 7.95973 4.06776C8.01636 3.93103 8.09937 3.80679 8.20402 3.70215C8.30867 3.5975 8.4329 3.51449 8.56963 3.45785C8.70636 3.40122 8.8529 3.37207 9.0009 3.37207C9.14889 3.37207 9.29543 3.40122 9.43216 3.45785C9.56889 3.51449 9.69312 3.5975 9.79777 3.70215L17.2978 11.2021C17.4025 11.3068 17.4856 11.4311 17.5422 11.5679C17.5988 11.7047 17.6279 11.8513 17.6277 11.9994C17.6275 12.1475 17.5981 12.2941 17.5412 12.4307C17.4843 12.5674 17.4009 12.6915 17.2959 12.7959Z"
          fill="#3d5cf5"
        />
      </svg>
    </button>
    <button
      class="lg:hidden flex gap-1 items-center text-primary-500 text-base font-semibold ms-auto"
      (click)="emitSeeAll()"
      *ngIf="showButton"
    >
      Ver
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        class="h-4 w-4"
      >
        <path
          d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7794 17.342 27.3978 17.5 27 17.5H17.5V27C17.5 27.3978 17.342 27.7794 17.0607 28.0607C16.7794 28.342 16.3978 28.5 16 28.5C15.6022 28.5 15.2206 28.342 14.9393 28.0607C14.658 27.7794 14.5 27.3978 14.5 27V17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H14.5V5C14.5 4.60218 14.658 4.22064 14.9393 3.93934C15.2206 3.65804 15.6022 3.5 16 3.5C16.3978 3.5 16.7794 3.65804 17.0607 3.93934C17.342 4.22064 17.5 4.60218 17.5 5V14.5H27C27.3978 14.5 27.7794 14.658 28.0607 14.9393C28.342 15.2206 28.5 15.6022 28.5 16Z"
          fill="#3d5cf5"
        />
      </svg>
    </button>
  </div>
  <div
    *ngIf="!isLoading; else skeleton"
    class="grid grid-cols-1 lg:grid-cols-3 gap-x-6 gap-y-6 lg:gap-y-10"
  >
    <a
      [routerLink]="['/cupom', campaign?.Id]"
      *ngFor="let campaign of campaigns"
    >
      <mobo-coupon [campaign]="campaign"></mobo-coupon>
    </a>
  </div>
  <ng-template #skeleton>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-x-6 gap-y-6 lg:gap-y-10">
      <mobo-coupon-skeleton></mobo-coupon-skeleton>
      <mobo-coupon-skeleton></mobo-coupon-skeleton>
      <mobo-coupon-skeleton></mobo-coupon-skeleton>
    </div>
  </ng-template>
</div>
